<div class="modal-header">
  <h5 class="modal-title" id="newUserLabel" i18n="@@CreateNewUserHeader">Benutzer hinzufügen</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <app-create-user #createUserComponent [customerId]="customerId" (newUserEvent)="newUserEvent($event)" (newAnonymousUserEvent)="newAnonymousUserEvent($event)"></app-create-user>
</div>

<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow"  data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
  <form [formGroup]="formService.form" (ngSubmit)="createUserComponent.onSubmit(formService.form.value)">
    <button type="submit" id="save" class="btn btn-save" [disabled]="getButtonDisabled() || createUserComponent.btnSaveDisabled" i18n="@@InviteButton">Benutzer hinzufügen</button>
  </form>
</div>
